export interface FilterOption {
  value: string | boolean | number;
  label: string;
  count?: number;
}

export type FilterType = "checkbox" | "dateRange" | "numberRange";

interface BaseFilterConfig {
  id: string;
  label: string;
  isVisible?: boolean;
}

export interface CheckboxFilterConfig extends BaseFilterConfig {
  type?: "checkbox";
  hasSearch?: boolean;
  keepOptionsOrder?: boolean;
  options: FilterOption[];
  selectedValues?: (string | boolean | number)[];
}

export interface DateRangeValue {
  start: string;
  end: string;
}

export interface DateRangeFilterConfig extends BaseFilterConfig {
  type: "dateRange";
  value?: DateRangeValue;
  startLabel?: string;
  endLabel?: string;
}

export interface NumberRangeValue {
  min: number;
  max: number;
}

export interface NumberRangeFilterConfig extends BaseFilterConfig {
  type: "numberRange";
  value?: NumberRangeValue;
  defaultMin?: number;
  defaultMax?: number;
  minLimit?: number;
  maxLimit?: number;
  minLabel?: string;
  maxLabel?: string;
}

export type FilterConfig = CheckboxFilterConfig | DateRangeFilterConfig | NumberRangeFilterConfig;

export type FilterValue = (string | boolean | number)[] | DateRangeValue | NumberRangeValue;

export type FilterValues = Record<string, FilterValue>;

export function isCheckboxFilter(config: FilterConfig): config is CheckboxFilterConfig {
  return config.type === "checkbox" || config.type === undefined;
}

export function isDateRangeFilter(config: FilterConfig): config is DateRangeFilterConfig {
  return config.type === "dateRange";
}

export function isNumberRangeFilter(config: FilterConfig): config is NumberRangeFilterConfig {
  return config.type === "numberRange";
}
